export const models = [
  {
    id: 'Seallm-7b-v3',
    modelName: 'Seallm-7b-v3',
  },
  {
    id: 'Seallm-7b-v2.5',
    modelName: 'Seallm-7b-v2.5',
  },
  {
    id: 'SQLCoder-7B-v2',
    modelName: 'SQLCoder-7B-v2',
  },
];
